module.exports = __webpack_public_path__ + "static/employsure-stats-3046e14f8b824a6492d8ccbd63810a9d.png";